module.exports = __webpack_public_path__ + "img/left-arrow1.c4d807f3.svg";